import jQuery from 'jquery';
import {ZIDX, ZIDXPage} from "../../../standalone/standaloneLibrary.js";

let $ = jQuery.noConflict();
export class ZIDXAccountListingIndexFileFieldEdit implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }

    getPageClass() {
        return "zidxAccountListingIndexFileFieldEditContainer";
    }


    render() {
        let self=this;
        this.zidx.loadFunctions.push(function () {
            const listing_index_file_field_id = $('#listing_index_file_field_id', self.zidx.peakidxShadowRoot).val();
            const listing_index_file_id = $('#listing_index_file_id', self.zidx.peakidxShadowRoot).val();
            const fieldNameInput = $("#listing_index_file_field_name", self.zidx.peakidxShadowRoot);
            const sourceCombinedField=$('#source_combined_field', self.zidx.peakidxShadowRoot);

            const labelInput = $('#listing_index_file_field_label', self.zidx.peakidxShadowRoot);
            const labelPlaceholder = labelInput.attr('placeholder')!;
            const assignmentTypeInput = $('input[type=radio][name=listing_index_file_field_assignment_type]', self.zidx.peakidxShadowRoot);
            const assignmentTypeChecked = $('input[type=radio][name=listing_index_file_field_assignment_type]:checked', self.zidx.peakidxShadowRoot);

            fieldNameInput.off('change.k04').on('change.k04', function (this: any) {
                let link=`/account/data-feeds/listing-index/file/fields/edit?listing_index_file_field_id=${listing_index_file_field_id}&listing_index_file_id=${listing_index_file_id}&listing_index_file_field_name=${encodeURIComponent(this.value)}&listing_index_file_field_assignment_type=${$('input[name=listing_index_file_field_assignment_type]:checked', self.zidx.peakidxShadowRoot).val()}`;
                console.log("link", link);
                window.location.href=link;
            });
            if(fieldNameInput.val()=="" && sourceCombinedField.val()==""){
                // hide interface
                $("#fieldFormContainerFirst", self.zidx.peakidxShadowRoot).hide();
                $("#fieldFormContainer", self.zidx.peakidxShadowRoot).hide();
                $("#fieldFormContainerPreview", self.zidx.peakidxShadowRoot).hide();
            }

            function onAssignmentTypeChange(value: string) {
                if(value=='2') {
                    $('#listing_index_file_field_heading_list_container', self.zidx.peakidxShadowRoot).show();
                }else{
                    $('#listing_index_file_field_heading_list_container', self.zidx.peakidxShadowRoot).hide();
                }
                if (value == '1' || value == '2' || value == '3') {
                    if (value == '3') {
                        $('#listing_index_file_field_label_container', self.zidx.peakidxShadowRoot).hide()
                        $("#field_name_container", self.zidx.peakidxShadowRoot).show()
                        $('#delimiter_container', self.zidx.peakidxShadowRoot).hide();
                        $('#index_container', self.zidx.peakidxShadowRoot).hide();
                        $('#exclude_container', self.zidx.peakidxShadowRoot).show();
                        $('#unique_values_container', self.zidx.peakidxShadowRoot).hide();
                    } else {
                        $('#unique_values_container', self.zidx.peakidxShadowRoot).show();
                        $('#listing_index_file_field_label_container', self.zidx.peakidxShadowRoot).show()
                        if (value == '1') {
                            $('#listing_index_file_field_label_label', self.zidx.peakidxShadowRoot).text('Header: ');
                            $("#field_name_container", self.zidx.peakidxShadowRoot).hide()
                            labelInput.attr('placeholder', '');
                            $('#index_container', self.zidx.peakidxShadowRoot).hide();
                            $('#delimiter_container', self.zidx.peakidxShadowRoot).show();
                        }else {
                            $('#listing_index_file_field_label_label', self.zidx.peakidxShadowRoot).text('Label: ');
                            $("#field_name_container", self.zidx.peakidxShadowRoot).show()
                            labelInput.attr('placeholder', labelPlaceholder);
                            $('#index_container', self.zidx.peakidxShadowRoot).show();
                            $('#delimiter_container', self.zidx.peakidxShadowRoot).show();
                        }
                        $('#exclude_container', self.zidx.peakidxShadowRoot).hide();
                    }
                    $('#source_combined_field_container', self.zidx.peakidxShadowRoot).hide();
                    $('#destination_field_container', self.zidx.peakidxShadowRoot).hide();
                    $('#destination_value_field_container', self.zidx.peakidxShadowRoot).hide();
                    $('#source_specific_field_container', self.zidx.peakidxShadowRoot).hide();
                    $('#exclude_container', self.zidx.peakidxShadowRoot).hide();
                } else {
                    $('#index_container', self.zidx.peakidxShadowRoot).hide();
                    $('#listing_index_file_field_label_container', self.zidx.peakidxShadowRoot).hide()
                    $("#field_name_container", self.zidx.peakidxShadowRoot).show()
                    $('#delimiter_container', self.zidx.peakidxShadowRoot).show();
                    if (value == '4') {
                        $('#unique_values_container', self.zidx.peakidxShadowRoot).show();
                        $('#source_combined_field_container', self.zidx.peakidxShadowRoot).hide();
                        $('#destination_field_container', self.zidx.peakidxShadowRoot).show();
                        $('#destination_value_field_container', self.zidx.peakidxShadowRoot).hide();
                        $('#source_specific_field_container', self.zidx.peakidxShadowRoot).hide();
                        $('#exclude_container', self.zidx.peakidxShadowRoot).show();
                    } else if (value == '5') {
                        $('#unique_values_container', self.zidx.peakidxShadowRoot).show();
                        $('#source_combined_field_container', self.zidx.peakidxShadowRoot).show();
                        $('#destination_field_container', self.zidx.peakidxShadowRoot).show();
                        $('#destination_value_field_container', self.zidx.peakidxShadowRoot).hide();
                        $('#source_specific_field_container', self.zidx.peakidxShadowRoot).hide();
                        $('#exclude_container', self.zidx.peakidxShadowRoot).hide();
                    } else if (value == '6') {
                        $('#unique_values_container', self.zidx.peakidxShadowRoot).show();
                        $('#source_combined_field_container', self.zidx.peakidxShadowRoot).hide();
                        $('#destination_field_container', self.zidx.peakidxShadowRoot).show();
                        $('#destination_value_field_container', self.zidx.peakidxShadowRoot).show();
                        $('#source_specific_field_container', self.zidx.peakidxShadowRoot).show();
                        $('#exclude_container', self.zidx.peakidxShadowRoot).hide();
                    }
                }
            }

            onAssignmentTypeChange(assignmentTypeChecked.val()! as string)
            assignmentTypeInput.off('change.k04').on('change.k04', function (this: any) {
                onAssignmentTypeChange(this.value)
            });

            $('#control_field_add', self.zidx.peakidxShadowRoot).off('click.k04').on('click.k04', function () {
                const value = $('#controls_source_field', self.zidx.peakidxShadowRoot).val()
                if (value) {
                    const input = $('#source_combined_field', self.zidx.peakidxShadowRoot);
                    input.val(function (this: any) {
                        if (this.value && this.value.trim())
                            return `${this.value} + ${value}`
                        else return `${value}`
                    });
                    input.get(0)!.scrollLeft = input.get(0)!.scrollWidth;
                }
            })
            $('#control_text_add', self.zidx.peakidxShadowRoot).off('click.k04').on('click.k04', function () {
                const value = $('#control_text', self.zidx.peakidxShadowRoot).val()
                if (value) {
                    const input = $('#source_combined_field', self.zidx.peakidxShadowRoot);
                    input.val(function (this: any) {
                        if (this.value && this.value.trim())
                            return `${this.value} + "${value}"`
                        else return `"${value}"`
                    });
                    input.get(0)!.scrollLeft = input.get(0)!.scrollWidth;
                }
            })

            $('#listing_index_file_field_source_value', self.zidx.peakidxShadowRoot).off('change.k04').on('change.k04', function (this: any) {
                if (this.value == '__other__') {
                    $('#source_other_value_field_container', self.zidx.peakidxShadowRoot).show();
                } else {
                    $('#source_other_value_field_container', self.zidx.peakidxShadowRoot).hide();
                }
            })
                .trigger('change')

        })
    }
}